import React from "react";

const TerminalMarketing = () => {
  return <div>Terminal Marketing Page</div>;
};

export default TerminalMarketing;
